import React, { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { getLscAdminAutopublishNightly } from '../api';
import LoadingState from '../components/LoadingState';
import { lscPath } from '../routing';

/** Lost Tapes. The first-week report is this league only. */
export const LOST_TAPES_LEAGUE_ID = 'league-d760ebf5-a412-4318-aa83-48bb9b0800eb';

export function LscAdminAutopublishNightlyPageView({
  text,
  loading,
  error,
}: {
  text: string | null;
  loading: boolean;
  error: string | null;
}) {
  return (
    <div className="space-y-4" data-testid="lsc-admin-autopublish-nightly">
      <div className="flex items-center justify-between gap-3">
        <h1 className="text-xl font-semibold text-white">Autopublish nightly report</h1>
        <Link to={lscPath('/admin')} className="text-sm text-primary-300">
          Back to admin
        </Link>
      </div>
      <p className="text-sm text-secondary-400">
        Lost Tapes, the last 24 hours. This page only reads the stored report.
      </p>
      {loading ? <LoadingState message="Loading the nightly report..." /> : null}
      {error ? (
        <p className="text-sm text-red-300" data-testid="lsc-admin-autopublish-nightly-error">
          {error}
        </p>
      ) : null}
      {text ? (
        <pre
          className="card whitespace-pre-wrap text-sm text-secondary-100"
          data-testid="lsc-admin-autopublish-nightly-text"
        >
          {text}
        </pre>
      ) : null}
    </div>
  );
}

const LscAdminAutopublishNightlyPage: React.FC = () => {
  const [text, setText] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    void getLscAdminAutopublishNightly(LOST_TAPES_LEAGUE_ID)
      .then((report) => {
        if (!cancelled) setText(report.text || '');
      })
      .catch(() => {
        if (!cancelled) setError('The nightly report is not available.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return <LscAdminAutopublishNightlyPageView text={text} loading={loading} error={error} />;
};

export default LscAdminAutopublishNightlyPage;
